"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var formik_1 = require("formik");
var ContentInput_1 = __importDefault(require("../ContentInput/ContentInput"));
var Form_1 = __importDefault(require("../Form/Form"));
var Checkbox_1 = __importDefault(require("../Checkbox/Checkbox"));
var PopUp_1 = __importDefault(require("../PopUp/PopUp"));
var PopUpTitle_1 = __importDefault(require("../PopUp/PopUpTitle/PopUpTitle"));
var PopUpText_1 = __importDefault(require("../PopUp/PopUpText/PopUpText"));
var PopUpLoading_1 = __importDefault(require("../PopUpLoading/PopUpLoading"));
var passwordIcon = require('../../assets/img/password.svg');
var PasswordPopUp = function (_a) {
    var title = _a.title, message = _a.message, errorAuth = _a.errorAuth, errorOther = _a.errorOther, cancelButton = _a.cancelButton, submitButton = _a.submitButton, passwordInputLabel = _a.passwordInputLabel, showPasswordLabel = _a.showPasswordLabel, onClearError = _a.onClearError, handleSubmit = _a.handleSubmit, handleCancel = _a.handleCancel, emptyFieldError = _a.emptyFieldError, loading = _a.loading;
    var validate = function (values) {
        var errors = {};
        if (values.password.trim().length < 4) {
            errors.password = emptyFieldError;
        }
        return errors;
    };
    var showError = function (type, error, formik, focused) {
        if (error) {
            return error;
        }
        if (formik.errors[type] && !focused) {
            return !formik.values[type].trim()
                ? formik.submitCount > 0
                    ? formik.errors[type]
                    : ''
                : formik.errors[type];
        }
        return '';
    };
    var setFieldStatus = function (type, error, formik, focused) {
        if (error) {
            return 'error';
        }
        if (!focused && formik.errors[type]) {
            return !formik.values[type].trim()
                ? formik.submitCount > 0
                    ? 'error'
                    : ''
                : 'error';
        }
        return '';
    };
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            password: ''
        },
        validate: validate,
        onSubmit: function (values) {
            if (!errorAuth && !errorOther && !formik.errors.password) {
                handleSubmit({ password: values.password });
            }
        }
    });
    var handleSubmitForm = function (e) {
        e.preventDefault();
        formik.handleSubmit();
    };
    var _b = (0, react_1.useState)(false), passwordFocused = _b[0], setPasswordFocused = _b[1];
    var _c = (0, react_1.useState)(false), showPassword = _c[0], setShowPassword = _c[1];
    var darkText = { color: 'black' };
    return (react_1.default.createElement(PopUp_1.default, { type: 'info', onCancel: handleCancel, cancelButton: cancelButton, onSubmit: formik.handleSubmit, submitButton: submitButton },
        react_1.default.createElement(PopUpTitle_1.default, { type: 'info' }, title),
        react_1.default.createElement(PopUpText_1.default, { type: 'info', style: darkText }, message),
        react_1.default.createElement(Form_1.default, { noValidate: true, onSubmitCapture: handleSubmitForm, onSubmit: handleSubmitForm, style: { padding: '0px 30px' } },
            react_1.default.createElement(ContentInput_1.default, { autoFocus: true, backgroundColor: 'transparent', type: showPassword ? 'text' : 'password', id: 'password', label: passwordInputLabel, iconSrc: passwordIcon, maxLength: 50, value: formik.values.password, error: showError('password', errorOther, formik, passwordFocused), status: setFieldStatus('password', errorOther, formik, passwordFocused), handleChange: function (e) {
                    formik.handleChange(e);
                    onClearError === null || onClearError === void 0 ? void 0 : onClearError();
                }, handleBlur: function (e) {
                    formik.handleBlur(e);
                    setPasswordFocused(false);
                }, handleFocus: function () { return setPasswordFocused(true); } }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Checkbox_1.default, { active: showPassword, checkboxStyle: { backgroundColor: 'transparent' }, textStyle: {
                        marginLeft: 10,
                        fontFamily: 'Raleway',
                        fontWeight: 'bold',
                        lineHeight: '20px',
                        maxWidth: '88%',
                        color: 'black'
                    }, clicked: function () { return setShowPassword(function (prev) { return !prev; }); } }, showPasswordLabel))),
        react_1.default.createElement(PopUpLoading_1.default, { loading: loading })));
};
PasswordPopUp.propTypes = {
    title: prop_types_1.default.string.isRequired,
    message: prop_types_1.default.string.isRequired,
    errorAuth: prop_types_1.default.string.isRequired,
    errorOther: prop_types_1.default.string.isRequired,
    onClearError: prop_types_1.default.func.isRequired,
    handleSubmit: prop_types_1.default.func.isRequired,
    handleCancel: prop_types_1.default.func.isRequired,
    loading: prop_types_1.default.bool
};
PasswordPopUp.defaultProps = {
    loading: false
};
exports.default = PasswordPopUp;
//# sourceMappingURL=PasswordPopUp.js.map